const host = "https://api.sendhelios.com/v1";

export interface IForm {
  id: string;
  org: string;
  gym: string;
  title: string;
  subtitle?: string;
  confirmation?: string;
  fields: IFormField[];
  lists: string[];
  createInboundMessage: boolean;
  collectName: boolean;
  collectEmail: boolean;
  theme: "light" | "dark";
  styles?: Record<string, string>;
  links?: Record<string, string>;
}

export interface IFormField {
  name: string;
  label: string;
  type: string;
  required: boolean | "true" | "false";
  placeholder?: string;
}

export interface IFormSubmissionField {
  name: string;
  value: string;
}
export interface ICreatePayload {
  customer: {
    phoneNumber: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    properties?: Record<string, any>;
  };
  fields: IFormSubmissionField[];
  metadata?: Record<string, any>;
}

export interface ICustomer {
  firstName?: string;
  lastName?: string;
  phoneNumber: string;
  email?: string;
  properties?: Record<string, any>;
}
async function get(path: string) {
  const response = await fetch(`${host}${path}`);
  return await response.json();
}

async function post(path: string, body: string | object) {
  const response = await fetch(`${host}${path}`, {
    method: "POST",
    body: typeof body === "string" ? body : JSON.stringify(body),
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await response.json();
}
export async function getForm(id: string): Promise<IForm> {
  return await get(`/forms/${id}`);
}
export async function createSubmission(id: string, data: ICreatePayload) {
  return await post(`/forms/${id}`, data);
}

export const BOOK_A_DEMO_FORM = "p6xc1jh2kg40o5tq";
export const CONTACT_US_FORM = "wx9hvjye3vo7ri3q";
export const BFS_FORM = "jydrsycf19ixitu7";
export const MARIANA_TEK_FORM = "oub0rvs1drqirizv";
